export enum StorageKey {
    Token = "authToken",
    UserRoles = "userRoles",
    UserEmail = "userEmail",
    TokenExpiry = "authTokenExpiry"
}

export class AppStorage {
    public static isAuthenticated(): boolean {
        return AppStorage.getAuthToken() !== null;
    }

    public static getAuthToken(): string | null {
        return AppStorage.getValue<string>(StorageKey.Token);
    }

    public static setAuthToken(token: string | null): void {
        AppStorage.setValue(StorageKey.Token, token);
    }

    public static getAuthTokenExpiry(): Date | null {
        const expiry = AppStorage.getValue<string>(StorageKey.TokenExpiry);
        return expiry ? new Date(expiry) : null;
    }

    public static setAuthTokenExpiry(expiry: Date | string | null): void {
        const date = expiry instanceof Date
            ? expiry
            : expiry
                ? new Date(expiry)
                : null;

        AppStorage.setValue(StorageKey.TokenExpiry,
            date && !Number.isNaN(date.getTime())
                ? date.toISOString()
                : null);
    }

    public static getUserRoles(): string[] {
        return AppStorage.getValue<string[]>(StorageKey.UserRoles) ?? [];
    }

    public static setUserRoles(roles: string[] | null): void {
        AppStorage.setValue(StorageKey.UserRoles, roles);
    }

    public static getUserEmail(): string | null {
        return AppStorage.getValue<string>(StorageKey.UserEmail);
    }

    public static setUserEmail(email: string | null): void {
        AppStorage.setValue(StorageKey.UserEmail, email);
    }

    private static setValue<T>(key: StorageKey, value: T | null): void {
        if (value === null) {
            localStorage.removeItem(key);
            return;
        }

        localStorage.setItem(key, JSON.stringify(value));
    }

    private static getValue<T>(key: StorageKey): T | null {
        const value = localStorage.getItem(key);

        if (value === null) {
            return null;
        }

        try {
            return JSON.parse(value) as T;
        } catch {
            localStorage.removeItem(key);
            return null;
        }
    }
}
